import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { pagination_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { filterSimple_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import { resultsInfo_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import { filterPreset_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterPreset_template";
import { filterDropdown_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import { multipleSelector_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";

declare var ko: any;

export class channelsList_template extends vnTemplate {

    protected isAvailableForUseFilter: multipleSelector_template;
    protected filterPreset: filterPreset_template;
    protected filter: filterSimple_template;
    protected itemsPerPageFilter: filterDropdown_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;

    protected getTemplateHtml(): string {

        return /* html */ `
            <div class="sub-header filter-preset w-justify">${ this.filterPreset.getHtmlBuild() }</div>


            <div class="sub-header">
                <div class="w-justify">
                    <div class="w-left">
                        ${this.isAvailableForUseFilter.getHtmlBuild()}
                    </div>
                </div>
            </div>

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-available-for-use"></div>
                </div>
            </div>

            <div class="list-header w-justify channels_playlists">
                <div class="w-left">
                    <div>
                        <button class="btn secondary icon i-channel" type="button" data-bind="event: { click: onClickAddChannel }">Add Channel</button>
                    </div>
                </div>

                <div class="w-center">
                    ${ this.filter.getHtmlBuild() }
                </div>

                <div class="w-right">
                    <div>
                        <label class="form-label form-label-box">Rows</label>
                        ${this.itemsPerPageFilter.getHtmlBuild()}
                    </div>
                    ${this.pagination.getHtmlBuild()}
                </div>
            </div>

            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ${ this.resultInfos.getHtmlBuild() }
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'about') }, css: { 'list-sort-desc': orderByAndDirection()=='about_DESC', 'list-sort-asc': orderByAndDirection()=='about_ASC' }">about</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'isAvailableForUse') }, css: { 'list-sort-desc': orderByAndDirection()=='isAvailableForUse_DESC', 'list-sort-asc': orderByAndDirection()=='isAvailableForUse_ASC' }">available for use</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">date created</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }">date updated</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: channels">
                        <tr class="cursor" data-bind="attr: { id : 'channels-' + id }, event: { click: $parent.onClickRow }">
                            <td><span data-bind="text: id"></span></td>
                            <td><span data-bind="text: name"></span></td>
                            <td><span data-bind="text: about"></span></td>
                            <td><span data-bind="text: isAvailableForUse ? 'Yes' : 'No'"></span></td>
                            <td><span data-bind="text: dateCreated"></span></td>
                            <td><span data-bind="text: dateUpdated"></span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        `;
    }

    protected initPartial(): void {
        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);
        this.filterPreset.getTemplateViewModel().searchPresetType('channelsList');

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);

        this.isAvailableForUseFilter = new multipleSelector_template(
            "isAvailableForUseFilter",
            this.getTemplateViewModel(),
            this.caller,
        );
        this.isAvailableForUseFilter.setLabel("Available For Use");
        this.isAvailableForUseFilter.setFilterContainerClass("margin-neg");
        this.isAvailableForUseFilter.setTagContainerId("selected-available-for-use");
        this.isAvailableForUseFilter.setTagContainerCaption("Available for use'");

        this.itemsPerPageFilter = new filterDropdown_template("itemsPerPageFilter", this.getTemplateViewModel(), this.caller);
        this.itemsPerPageFilter.setOptions([
            { id: 25, name: '25' },
            { id: 50, name: '50' },
            { id: 100, name: '100' },
        ]);

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string {
        return "channelsList_template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {

        return {
            orderBy: ko.observable("name"),
            orderByAndDirection: ko.observable("name_ASC"),
            orderByDirection: ko.observable("ASC"),
            channels: ko.observableArray([]),

            onClickReorder: this.onClickReorder.bind(this),
            onClickRow: this.onClickRow.bind(this),
            onClickAddChannel: this.onClickAddChannel.bind(this),
        };
    }

    protected getItemsPerPageSelectedOption() {
        let itemsPerPage = this.itemsPerPageFilter.getSelectedOption();
        const itemsPerPageFilterOptions = this.itemsPerPageFilter.getOptions();
        if(itemsPerPageFilterOptions.indexOf(itemsPerPage) == -1){
            itemsPerPage = itemsPerPageFilterOptions[0];
        }

        return itemsPerPage;
    }

    // implementation of base class [vnTemplate]
    public getViewModelForRequest() {


        this.pagination.getTemplateViewModel().itemPerPage = this.getItemsPerPageSelectedOption().id;

        return {
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            searchPresetName: this.getTemplateViewModel().filterPreset.searchPresetName(),
            searchPresetType: this.getTemplateViewModel().filterPreset.searchPresetType(),
            filters: {
                isAvailableForUse: this.isAvailableForUseFilter.getSelectedItems(),
                itemsPerPage: this.pagination.getTemplateViewModel().itemPerPage,
                keywords: this.getTemplateViewModel().filter.filterKeyword,
            },
        }
    }

    protected getChannels() {
        return this.getTemplateViewModel().channels();
    }

    public setChannelList(channels): void {
        channels.forEach(channel => {
            channel.checked = channel.checked == null ? ko.observable(false) : channel.checked;
        });

        this.getTemplateViewModel().channels(channels);
    }

    public getViewModelForUpdate() {
        let channels = this.getChannels();
        let idChannels = [];
        channels.forEach(channel => {
            if (channel.checked()) {
                idChannels.push(channel.id);
            }
        });

        return {
            idChannels: idChannels,
        }
    }

    public setViewModelFromRequest(urlParams){
        if (urlParams != null) {
            if (urlParams.itemsPerPage) {
                this.itemsPerPageFilter.setSelectedOption(urlParams.itemsPerPage);
            } else {
                this.itemsPerPageFilter.setSelectedOption(25);
            }

            if (urlParams.orderBy != null && urlParams.orderByDirection) {
                this.getTemplateViewModel().orderBy(urlParams.orderBy);
                this.getTemplateViewModel().orderByDirection(urlParams.orderByDirection);
                this.getTemplateViewModel().orderByAndDirection(`${urlParams.orderBy}_${urlParams.orderByDirection}`);
            }

            let keywordString = urlParams.keywords;
            if(keywordString){
                this.filter.getTemplateViewModel().filterKeyword(keywordString);
            }

            this.setFilterSelectedItems(this.isAvailableForUseFilter, urlParams.isAvailableForUse);
        }
    }

    public setDefaults(){
    }

    public setSearchPresets(presets){

        this.filterPreset.setSearchPresets(presets);
    }

    public setIsAvailableForUseFilter(items) {
        this.isAvailableForUseFilter.setItems(items);
    }

    public addCreatedPresetToList(response){

        this.filterPreset.addCreatedPresetToList(response);
    }

    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(`${value}_${data.orderByDirection()}`);

        this.caller.filterList();
    }

    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public onClickRow(channel) {
        this.caller.viewChannel(channel.id);
    }

    public onClickAddChannel() {
        this.caller.addChannel();
    }

    public setFilterSelectedItems(objFilter, urlParams) {
        let splitString = [];

        // Multi select filters.
        if (Array.isArray(urlParams)) {
            urlParams = urlParams.toString();
        }
        if (urlParams) {
            if (typeof urlParams == "string") {
                splitString = urlParams.split(",");
            } else {
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {
                if (!isNaN(Number(id))) {
                    id = Number(id);
                } else {
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        } else {
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/channelsList_template.ts